import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/lib/contact";

/**
 * Sticky Call bar visible on mobile only.
 * IMPORTANT: The site includes a fixed "Made with Emergent" badge at bottom-right
 * (178x40, z-9999). To avoid the Call CTA sitting under that badge, we place the
 * primary Call button on the LEFT of the bar and keep the right side free.
 */
export const MobileCallBar = () => {
    return (
        <div
            data-testid="mobile-sticky-call-bar"
            className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-tp-forest text-white shadow-[0_-10px_30px_rgba(11,27,18,0.35)] pb-safe"
            role="region"
            aria-label="Call Tipping Point Skips"
        >
            <div className="px-3 py-2.5 flex items-center gap-3">
                {/* Left: full call CTA — sits away from the Emergent badge */}
                <a
                    href={PHONE_HREF}
                    data-testid="mobile-sticky-call-button"
                    className="tp-btn-primary tp-focus text-sm h-12 px-4 flex-1 justify-center max-w-[60%]"
                    aria-label={`Call ${PHONE_DISPLAY}`}
                >
                    <Phone size={18} strokeWidth={2.6} />
                    <span className="font-heading text-base tabular-nums">
                        Call {PHONE_DISPLAY}
                    </span>
                </a>
                {/* Right: label sits above the Emergent badge; kept tight and single-line */}
                <div className="hidden xs:flex flex-col justify-center min-w-0">
                    <div className="text-[10px] uppercase tracking-[0.14em] text-tp-gold/90 leading-tight whitespace-nowrap">
                        Free quote
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileCallBar;
